import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/storageHardLimitModalQuery.graphql';
import type { ModalProps, StorageHardLimitQueries } from './storage-hard-limit-modal';

export type EntryPointParams = {
	/**
	 * When true, the modal preloads the GUPS profile data used to decide whether the
	 * "Contact sales" message should be shown (twcg-1533-pls-contact-path-disco).
	 */
	shouldCheckContactSalesEligibility?: boolean;
	/** The Atlassian account id of the current user */
	userId?: string | null;
};

type StorageHardLimitEntryPointComponent = EntryPointComponent<
	StorageHardLimitQueries,
	Record<string, never>,
	ModalProps,
	Record<string, never>
>;

const storageHardLimitEntryPoint: EntryPoint<
	StorageHardLimitEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<StorageHardLimitEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-awareness-storage-hard-limit-modal" */ './storage-hard-limit-modal',
		{
			moduleId: 'edition-awareness-storage-hard-limit-modal',
		},
	),
	getPreloadProps: ({ shouldCheckContactSalesEligibility = false, userId }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			storageHardLimitModalQuery: {
				parameters,
				variables: {
					shouldCheckContactSalesEligibility,
					// The GUPS fields are skipped when eligibility isn't being checked, so the
					// required $userId variable is satisfied with a placeholder
					userId: userId ?? '',
				},
			},
		},
	}),
});

export default storageHardLimitEntryPoint;
